var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-container"},[_c('div',{ref:"dashboard",staticClass:"dashboard"},[_c('Common'),_c('Sidebar',{on:{"menu-close":function($event){return _vm.$refs['dashboard'].classList.remove('sidebar-visible')}}}),_c('Content',{on:{"menu-click":function($event){return _vm.$refs['dashboard'].classList.add('sidebar-visible')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }